module.exports = __webpack_public_path__ + "static/img/menu.122d7e4f.svg";